import { NgModule } from '@angular/core';
import { FiADIntegrationADImportComponent } from './ad-import.component';
import { FiAppTextSharedModule } from '../../../shared/app-text';
import { AdImportChooseGroupsDialogComponent } from './ad-import-choose-groups-dialog/ad-import-choose-groups-dialog.component';
import { UtilitiesModule } from '../../../utilities/utilities.module';

@NgModule({
    imports: [FiAppTextSharedModule, UtilitiesModule],
    declarations: [FiADIntegrationADImportComponent, AdImportChooseGroupsDialogComponent],
    exports: [FiADIntegrationADImportComponent],
})
export class FiADIntegrationADImportModule {}
